import moment, { Moment } from "moment";

export default class ImpostoInternacional implements IImpostoInternacional {
  public criadoEm!: Moment;
  public dataBase!: Moment;
  // Resultado mensal (cópia para referência, como no modelo nacional)
  public resultado!: ResultadoInternacionalMensal;
  // Abatimentos (propagação de prejuízos, como no modelo nacional)
  public abatimentoAnterior!: AbatimentoInternacional;
  public abatimento!: AbatimentoInternacional;
  // Imposto mensal (15% sobre resultado do mês - informativo)
  public impostoMensal!: number;
  // Imposto anual devido (15% sobre resultadoAcumulado - DARF anual)
  public impostoAnualDevido!: number;

  // Imposto pago no exterior (Lei 14.754/2023), em BRL. Dedutível dos 15%
  // bem a bem; o excedente não é restituído nem vai para outro bem ou ano.
  public impostoRetido!: number; // do mês
  public impostoRetidoAno!: number; // acumulado no ano-calendário
  public impostoCompensavel!: number; // Σ por bem de min(retido, devido do bem)
  public impostoEstimadoDIRPF!: number; // max(0, anual devido − compensável)
  public demonstrativo!: DemonstrativoBem[];

  constructor(param: IImpostoInternacional) {
    Object.assign(this, param);
    this.impostoRetido = param.impostoRetido ?? 0;
    this.impostoRetidoAno = param.impostoRetidoAno ?? 0;
    this.impostoCompensavel = param.impostoCompensavel ?? 0;
    this.impostoEstimadoDIRPF =
      param.impostoEstimadoDIRPF ??
      Math.max(0, (param.impostoAnualDevido ?? 0) - this.impostoCompensavel);
    this.demonstrativo = param.demonstrativo ?? [];
  }

  static parse(json: any): ImpostoInternacional {
    return new ImpostoInternacional({
      ...json,
      criadoEm: moment(json.criadoEm),
      dataBase: moment(json.dataBase),
    });
  }

  toJSON(): IImpostoInternacionalJson {
    return {
      criadoEm: this.criadoEm.toISOString(),
      dataBase: this.dataBase.toISOString(),
      resultado: this.resultado,
      abatimentoAnterior: this.abatimentoAnterior,
      abatimento: this.abatimento,
      impostoMensal: this.impostoMensal,
      impostoAnualDevido: this.impostoAnualDevido,
    };
  }
}

export interface IImpostoInternacionalJson {
  criadoEm: string;
  dataBase: string;
  resultado: ResultadoInternacionalMensal;
  abatimentoAnterior: AbatimentoInternacional;
  abatimento: AbatimentoInternacional;
  impostoMensal: number;
  impostoAnualDevido: number;
}

export interface AbatimentoInternacional {
  prejuizo: number;
}

// Linha do "Demonstrativo de Apuração" da DIRPF, no acumulado do ano.
export interface DemonstrativoBem {
  ativo: string;
  moeda: string;
  ganhoPrejuizo: number;
  impostoDevido: number;
  impostoPago: number;
  saldo: number;
}

export interface ResultadoInternacionalMensal {
  ganhoCapital: number;
  rendimentos: number;
  resultadoTotal: number;
}

interface IImpostoInternacional {
  criadoEm: Moment;
  dataBase: Moment;
  resultado: ResultadoInternacionalMensal;
  abatimentoAnterior: AbatimentoInternacional;
  abatimento: AbatimentoInternacional;
  impostoMensal: number;
  impostoAnualDevido: number;  impostoRetido?: number;
  impostoRetidoAno?: number;
  impostoCompensavel?: number;
  impostoEstimadoDIRPF?: number;
  demonstrativo?: DemonstrativoBem[];
}